import { useMemo } from "react";
export var useFiltersParser = function (filtersApplied) {
    return useMemo(function () {
        var _a, _b, _c, _d;
        // Si no hay filtros o no es un objeto, retornar null
        if (!filtersApplied || typeof filtersApplied !== "object") {
            return null;
        }
        var filters = {};
        // Extraer filtro deleted directamente del objeto
        if (((_a = filtersApplied.deleted) === null || _a === void 0 ? void 0 : _a.id) && ((_b = filtersApplied.deleted) === null || _b === void 0 ? void 0 : _b.value)) {
            filters.deleted = filtersApplied.deleted.value;
        }
        // Extraer filtro hasRole directamente del objeto
        if (((_c = filtersApplied.hasRole) === null || _c === void 0 ? void 0 : _c.id) && ((_d = filtersApplied.hasRole) === null || _d === void 0 ? void 0 : _d.value)) {
            filters.hasRole = filtersApplied.hasRole.value;
        }
        // Si no hay filtros con valores, retornar null
        if (Object.keys(filters).length === 0) {
            return null;
        }
        return filters;
    }, [filtersApplied]);
};
